import Vue from 'vue'
import { Button,Form, FormItem,Input,Message,Container,Header,Main,Footer,Menu,Submenu,MenuItemGroup,MenuItem,Carousel,CarouselItem } from 'element-ui'



Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.prototype.$message = Message//把Message组件挂载到全局对象上